import {
  Action,
  ActionType,
  IConsultationDetailsResponse,
} from "models/consultations/consultationDetails";
import createReducer from "redux/createReducer";

export interface ConsultationDetailsReducerType {
  loading: boolean;
  error?: string;
  consultationDetailsResponse?: IConsultationDetailsResponse;
}

const defaultState: ConsultationDetailsReducerType = {
  loading: false,
  error: undefined,
  consultationDetailsResponse: undefined,
};

export const consultationDetailsReducer =
  createReducer<ConsultationDetailsReducerType>(defaultState, {
    [ActionType.GET_CONSULTATION_DETAILS](
      state: ConsultationDetailsReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_CONSULTATION_DETAILS_ERROR](
      state: ConsultationDetailsReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        consultationDetailsResponse: undefined,
      };
    },

    [ActionType.GET_CONSULTATION_DETAILS_SUCCESS](
      state: ConsultationDetailsReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        consultationDetailsResponse: action.payload,
      };
    },

    [ActionType.GET_CONSULTATION_DETAILS_RESET](
      state: ConsultationDetailsReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        consultationDetailsResponse: undefined,
      };
    },
  });
